import React, { useContext, useState } from 'react';
import Image from 'react-bootstrap/Image';
import Logo from '../../../margretlogo.png';
import Button from 'react-bootstrap/Button'
import Table from 'react-bootstrap/Table';
import { Col, Container, Row } from 'react-bootstrap';
import { GlobalContext } from '../../context/provider';
import moment from "moment";
import '../css/onprinttoggle.css';
import numberbeautifuly from '../../../utils/numberbeautify';

const Loan_report_detail_print = props => {
    const { reportState, reportDispatch } = useContext(GlobalContext);
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    return (
        <div className='print_show'>
            <Container>
                <Row className='justify-content-md-center mt-3'>
                    <Image src={Logo} style={{ width: 110, height: 100 }} />
                    <center><span>لیستی قەرزی فێرخواز لە باخچەی منداڵان لە بەرواری {moment(props.from).format('YYYY-MM-DD')} بۆ بەرواری {moment(props.to).format('YYYY-MM-DD')}</span></center>
                </Row>
                <Row className='justify-content-md-center mt-4'>
                    <table>
                        <thead style={{ border: '2px solid', textAlign: 'center' }}>
                            <tr style={{ border: '2px solid', textAlign: 'center' }}>
                                <th>ژمارە</th>
                                <th>ناو</th>
                                <th>پۆل</th>
                                <th>ژمارە</th>
                                <th>ژمارەی وەسڵ</th>
                                <th>کۆی قەرز</th>
                                <th>کۆی ماوە</th>
                            </tr>
                        </thead>
                        <tbody style={{ border: '2px solid', textAlign: 'center', fontSize: 12 }}>
                            {reportState.student_stat.map((lis, index) => (
                                // (lis.total_ex - lis.total_inc) != 0 ?
                                <tr style={{ border: '2px solid', textAlign: 'center' }}>
                                    <td>{index + 1}</td>
                                    <td>{lis.student_name}</td>
                                    <td>{lis.class_name}</td>
                                    <td>{lis.student_phone1}</td>
                                    <td>{lis.student_code}</td>
                                    <td>{numberbeautifuly(lis.total_ex)} IQD</td>
                                    <td>{numberbeautifuly(lis.total_ex - lis.total_inc)} IQD</td>
                                </tr>
                            ))}
                            <tr style={{ border: '2px solid', textAlign: 'center' }}>
                                <td style={{ textAlign: 'center' }} colSpan={4}>کۆی قەرزی ماوە</td>
                                <td style={{ textAlign: 'center' }} colSpan={2}>{numberbeautifuly(reportState.total_loan)} IQD</td>
                            </tr>
                        </tbody>
                    </table>
                </Row>
                <div style={{ width: '100%', marginTop: '5vh', display: 'flex', justifyContent: 'space-between' }}>
                    <div style={{ width: '50%' }}>
                        <span>سارا سعدی عمر<br />
                            ژمێریار</span>
                    </div>
                    <div style={{ width: '50%', display: 'flex', justifyContent: "flex-end" }}>
                        <span>ئاڤان ئەحمەد حەمە<br />
                            بەڕێوەبەر</span>
                    </div>
                </div>
            </Container>
        </div>
    )
}

export default Loan_report_detail_print